export interface RunLaborAmendPostAmendmentEffectsResult {
  failedEffects: Array<() => Promise<void>>;
  firstError: unknown | undefined;
}

/**
 * Runs registered post-amendment effects sequentially, retaining failures for retry.
 */
export async function runLaborAmendPostAmendmentEffects(
  effects: Array<() => Promise<void>>,
): Promise<RunLaborAmendPostAmendmentEffectsResult> {
  const failedEffects: Array<() => Promise<void>> = [];
  let firstError: unknown;

  for (const effect of effects) {
    try {
      await effect();
    } catch (error) {
      failedEffects.push(effect);
      if (!firstError) {
        firstError = error;
      }
    }
  }

  return { failedEffects, firstError };
}
